import { Guid } from 'Lib/Guid';

interface IReportConfiguration {
  Id: string;
  ConfigurationType: string;
  Name: string;
  Content: string;
  DocumentId?: number;
  DocumentName: string;
  IsSystemConfiguration: boolean;
  BaseConfigurationUUID: Guid | null;
  BaseConfigurationName: string | null;
  IsDocumentConfiguration: boolean;
  UsedInReports: Array<{ value: number; label: string }>;
  Messages?: Array<any>;
  WorkOrderUUID?: Guid;
  WorkOrderName?: string;
}

interface IReportConfigurationGroupList {
  Items: IReportConfigurationGroup[];
}
interface IReportConfigurationGroup {
  Id: Guid;
  Name: string;
  SystemDefined: boolean;
}

export const reportConfigurationTypeOptions = [
  { label: 'Report', value: 'Report' },
  { label: 'Entity Content', value: 'EntityContent' },
  { label: 'Method', value: 'Method' },
  { label: 'Qestlab Bulk Entry', value: 'QestlabBulkEntry' },
  { label: 'Custom Header Data', value: 'CustomHeaderData' },
  { label: 'Hive Metadata', value: 'HiveMetadata' },
];

export type { IReportConfiguration, IReportConfigurationGroup, IReportConfigurationGroupList };
